<template>
  <div class="i-detail-similar">
    <div class="i-detail-similar-title">
      <span v-if="sns_type=='instagram'||sns_type=='tiktok'||sns_type=='twitter'">フォロワー数の推移</span>
      <span v-else-if="sns_type=='instagram_eg' || sns_type=='tiktok_eg' ">エンゲージメント率の推移</span>
      <span v-else-if="sns_type=='youtube'">チャンネル登録者数の推移</span>
      <span v-else-if="sns_type=='youtube_view' || sns_type=='tiktok_view'">視聴回数の推移</span>
      <span v-else-if="sns_type=='youtube_average' || sns_type=='tiktok_average'">１動画あたりの平均視聴回数の推移</span>
      <div class="flex-space"></div>
      <div>
        <el-radio-group v-model="date_type" size="mini" @change="loadTransition()">
          <!-- データ増に伴い取得間隔が伸びた為日別推移を非表示 -->
          <!-- <el-radio-button v-if="sns_type!='youtube_average'"  label="day"></el-radio-button> -->
          <el-radio-button v-if="sns_type!='youtube_average'" label="week"></el-radio-button>
          <el-radio-button v-if="sns_type!='youtube_average'" label="month"></el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="i-detail-similar-wrap" id="transition-wrap" v-loading="loading" v-if="graph_data.data.length > 3">
      <InfluencerTransitionGraph v-if="!loading" :sns_type="sns_type" :graph_data="graph_data" :reRender="reRender" @update-data="relayData"/>
    </div>
    <div class="report-nopost" style="height:auto" v-else>
      <img src="../../assets/report_image_3.png" style="opacity: 0.7; height:160px" alt />
      <div style="font-size: 20px;font-weight: 700; margin-bottom:10px">
        もう少しお待ちください
      </div>
      <div>
        データが不足しているため現在表示できません
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const mode = process.env.VUE_APP_MODE;
const transitionAPI = root + "/api/search/transition";
import InfluencerTransitionGraph from "../charts/InfluencerTransitionGraph";

export default {
  name: "transitionData",
  components: {
    InfluencerTransitionGraph,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    sns_type: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mode: mode,
      date_type: "week",
      graph_data: {
        type: Array,
        default: null,
        data: {
          type: Array,
          default: null,
        },
      },
      reRender: 0,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    this.loadTransition();
  },
  methods: {
    loadTransition() {
      this.axios
        .get(transitionAPI, {
          params: {
            token: this.token,
            sns_type: this.sns_type,
            date_type: this.date_type,
            influencer: this.id,
          },
        })
        .then((response) => {
          this.graph_data = response.data.graph_data;
          this.render += 1;
        })
        .catch(() => {});
    },
    relayData(tabType, searchPeriodFrom, searchPeriodTo) {
      this.$emit("update-data", tabType, searchPeriodFrom, searchPeriodTo);
    },
  },
  watch: {
    id() {
      this.loadTransition();
    },
  },
};
</script>

<style></style>
